import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ToggleChangeEventDetail, ToggleCustomEvent } from '@ionic/core';
import { BuddyLanguageComponent } from '../../buddy/buddy-language/buddy-language.component';

@Component({
  selector: 'app-chatbot-settings',
  templateUrl: './chatbot-settings.page.html',
  styleUrls: ['./chatbot-settings.page.scss'],
})
export class ChatbotSettingsPage implements OnInit {
  availableLanguages = [
    {
      language: 'de',
      localize: $localize`:@@pages.chatbot.settings.language-de:Missing translation`,
    },
    {
      language: 'en',
      localize: $localize`:@@pages.chatbot.settings.language-en:Missing translation`,
    },
  ];
  selectedLanguage: string;
  shouldSuggestQuestions: boolean;

  title = $localize`:@@pages.chatbot.settings.title:Missing translation`;

  titleSuggestedQuestions = $localize`:@@pages.chatbot.settings.title-suggested-questions:Missing translation`;
  descriptionSuggestedQuestions = $localize`:@@pages.chatbot.settings.description-suggested-questions:Missing translation`;

  titleLanguage = $localize`:@@pages.chatbot.settings.title-language:Missing translation`;
  descriptionLanguage = '';

  titleHelp = $localize`:@@pages.chatbot.settings.title-help:Missing translation`;
  descriptionHelp = $localize`:@@pages.chatbot.settings.description-help:Missing translation`;
  dataProtection = $localize`:@@page.landing-page.slide5.textHeader:Missing translation`;

  constructor(
    private location: Location,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
    this.descriptionLanguage = this.availableLanguages[0].localize;
  }

  onBackClicked() {
    this.location.back();
  }

  toggleSuggestions(event: ToggleCustomEvent<ToggleChangeEventDetail>) {
    this.shouldSuggestQuestions = event.detail.checked;
  }

  async onLanguageIconClicked() {
    await this.modalCtrl
      .create({
        component: BuddyLanguageComponent,
        cssClass: 'mini-modal',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        componentProps: {
          languages: this.availableLanguages,
        },
      })
      .then((modal) => modal.present());
  }

  onLanguageChange(index: number) {
    this.selectedLanguage = this.availableLanguages[index].language;
    this.descriptionLanguage = this.availableLanguages[index].localize;
  }

  onHelpIconClicked() {
    window.open('https://handbuch.ztm.de/buddy-ueberblick', '_blank');
  }
}
